<template>
  <TransitionGroup
    name="list"
    tag="container"
    :class="[
      tracks.length !== 0 ? `${itemsStart}` : 'justify-start',
      'flex flex-wrap gap-4 w-full',
    ]"
  >
    <div v-if="addTrackEnabled" class="w-47/100 sm:w-211">
      <div
        @click="addTrack"
        class="flex flex-col items-center rounded-8 cursor-pointer w-full h-232 sm:h-271 border-dashed border border-grayscale-40 p-4 justify-center gap-12"
      >
        <div
          class="w-16 h-16 bg-grayscale-13 rounded-full flex items-center justify-center"
        >
          <p class="text-grayscale-7 text-32 font-bold">+</p>
        </div>
        <p class="text-grayscale-40 font-medium text-13">Add New</p>
      </div>
    </div>
    <div
      class="w-47/100 sm:w-211"
      v-for="(track, index) in tracks"
      :key="index"
    >
      <track-component
        :isSelected="selected === track._id"
        :track="track"
        @click="onTrackSelect(track)"
      />
    </div>
  </TransitionGroup>
  <EditTrack
    v-if="isModalVisible && selectedTrack"
    :track="selectedTrack"
    @close="isModalVisible = false"
  />
</template>

<script setup lang="ts">
import EditTrack from "@/components/EditTrack.vue";
import TrackComponent from "@/components/Track.vue";
import { useTrackStore } from "@/store/track";
import { Track } from "@/types/track";
import { computed, PropType, ref } from "vue";

const props = defineProps({
  itemsStart: {
    type: String,
    default: "",
  },
  select: {
    type: Boolean,
    default: false,
  },
  selected: {
    type: String,
    default: null,
  },
  addTrackEnabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["trackClick", "addTrack"]);

const addTrack = () => {
  emit("addTrack");
};

const isModalVisible = ref(false);
const trackStore = useTrackStore();
const tracks = computed(() => trackStore.tracks);
const selectedTrack = ref<Track | null>(null);

const onTrackSelect = (track: Track) => {
  selectedTrack.value = track;
  if (!props.select) {
    isModalVisible.value = true;
  } else {
    emit("trackClick", track);
  }
};
</script>
